import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Vad kostar ett tillfälligt serveringstillstånd?";
const SHORT_ANSWER = "Vanligen 1 000–2 500 kr för slutet sällskap, 3 000–6 000 kr för allmänheten – avgiften sätts av varje kommun.";

export const Route = createFileRoute("/fraga/hur-mycket-kostar-tillfalligt-tillstand")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Vad kostar ett tillfälligt serveringstillstånd" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Storstäder ligger högre, mindre kommuner lägre. Vid återkommande evenemang under en säsong kan kommunen erbjuda 'säsongsavgift'. Kontrollera taxan på kommunens webbplats."}
      source={{ label: "Folkhälsomyndigheten – Serveringstillstånd (vägledning)", href: "https://www.folkhalsomyndigheten.se/livsvillkor-levnadsvanor/alkohol-narkotika-dopning-tobak-och-spel-andts/tillsynsvagledning-enligt-alkohollagen/serveringstillstand/" }}
      extraSources={[]}
      deepGuide={{ to: "/tillfalligt-serveringstillstand", label: "Tillfälligt tillstånd – avgifter" }}
      related={[{"to": "/fraga/vad-ar-gardsforsaljning-2026", "label": "Vad är gårdsförsäljning enligt det nya regelverket 2026?"}, {"to": "/fraga/vem-far-salja-pa-gardsforsaljning", "label": "Vem får sälja alkohol via gårdsförsäljning?"}, {"to": "/fraga/food-truck-vad-galler", "label": "Vad gäller för food truck och alkoholservering?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Vad kostar ett tillfälligt serveringstillstånd?" },
      { name: "description", content: "Vanligen 1 000–2 500 kr för slutet sällskap, 3 000–6 000 kr för allmänheten – avgiften sätts av varje kommun." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/hur-mycket-kostar-tillfalligt-tillstand" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/hur-mycket-kostar-tillfalligt-tillstand" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/hur-mycket-kostar-tillfalligt-tillstand",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Vad kostar ett tillfälligt serveringstillstånd", url: "https://alkoholprovet.se/fraga/hur-mycket-kostar-tillfalligt-tillstand" },
      ]),
    ],
  }),
});
